exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tree-menu{color:#37474f;.label-wrapper{padding-bottom:10px;margin-bottom:10px;border-bottom:1px solid #ccc;.has-children{cursor:pointer}}}.my-offer{padding:.4rem .75rem}.category-label,.my-offer{border-bottom:1px solid #e0e0e0}.category-label{padding:1.5rem .75rem;background-color:#eee}.icon-arrow-down,.icon-arrow-right{margin-left:10px;font-weight:700}.icon-ghost{color:#039be5;font-weight:700}.icon-settings{color:#43a047;font-weight:700}.icon-rocket{color:#f57c00;font-weight:700}.icon-grid{color:#d81b60;font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-63039796","scoped":false,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/TreeMenu.vue
// module id = 436
// module chunks = 1